var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-selector',_vm._g(_vm._b({staticClass:"courier-hub-user-group-selector",attrs:{"items":_vm.userGroups,"formattedValue":_vm.formattedValue}},'custom-selector',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }